<template>
	<div class="upgrade-view">
		<div class="container-fluid p-0" style="background-color: none !important;">
			<b-tabs card class="nonobg">
				<b-tab title="Seznam sledování" class="nobg">
					<div class="container-fuild test py-0 py-lg-4 ">
						<div class="row mt-0 mt-lg-4">
							<div class="col-lg-1">
							</div>
							<div class="input-group col-lg-3">
								<input type="text" class="form-control" v-model="vyhledavani" placeholder="Jméno sledování/RUIAN" aria-label="Recipient's username" aria-describedby="button-addon2">
								<div class="input-group-append">
									<button class="btn btn-outline-primary" style="background-color: white;" type="button" id="button-addon2" @click="vyhledavani = ''"> X </button>
								</div>
							</div>
						</div>
						<div class="row mt-4">
							<div class="col-lg-1">

							</div>
							<div v-if="fetchingWatching" class="col-lg-3 my-list my-list-min">
								<b-spinner style="margin-top: 40px;" label="Spinning"></b-spinner>
							</div>

							<ul v-else class="list-group col-xs col-sm-12 col-md-8 px-sm-0 mx-sm-0 col-lg-3 my-list my-list-min">
								<li class="list-group-item cursor-pointer text-left" v-if="newWatching.length < 1" >Žádné sledování</li>
								<li class="list-group-item cursor-pointer text-left"
								:class="{ active: item.id === selectedWatchedId }"
								v-for="item of newWatching"
								:key="item.id"
								@click="setWatchedActive(item)"
								> {{ item.first_name }} {{ item.last_name }}  </li>
							</ul>

							<div class="col-lg-1">
							</div>

							<div v-if="selectedWatched" class="col mt-4 mt-lg-0 mr-md-4 info-back">
								<!-- Info row -->
								<div class="row d-none d-md-flex justify-content-start p-4">
									<h3 class="col text-left text-secondary">{{ selectedWatched.first_name }} {{ selectedWatched.last_name }}</h3>
									<div class="col-6 text-left">
										<div class="text-info my-word text-left">Telefon:<span class="text-secondary my-word-response"> {{ selectedWatched.phone }}</span></div>
										<div class="text-left text-info my-word">Email:<span class="text-secondary text-left my-word-response"> {{ selectedWatched.email }} </span> </div>
									</div>
								</div>

								<div class="row d-md-none pt-3 px-1">
									<h3 class="col text-left text-secondary">{{ selectedWatched.first_name }} {{ selectedWatched.last_name }}</h3>
								</div>
								<div class="row d-md-none px-3">
									<div class="text-info my-word text-left">Telefon:<span class="text-secondary my-word-response"> {{ selectedWatched.phone }}</span></div>
								</div>
								<div class="row d-md-none px-3">
									<div class="text-left text-info my-word">Email:<span class="text-secondary text-left my-word-response"> {{ selectedWatched.email }} </span> </div>
								</div>

								<!-- Adresy part -->
								<div class="row d-none d-md-flex px-4" >
									<ul class="list-group ml-3 col-5 my-list-small">
										<li class="list-group-item cursor-pointer text-left" v-if="selectedWatched.ruians.length < 1">Žádné sledování</li>
										<li class="list-group-item cursor-pointer text-left" v-for="(item, index) of selectedWatched.ruians" :key="index"> {{ item }} </li>
									</ul>

									<div class="col-1">

									</div>
									<div class="col-lg-3 mb-3 mt-0 justify-content-md-left text-left px-0" >
										<div class="form-check">
											<input class="form-check-input" type="checkbox" v-model="selectedWatched.nordic" disabled id="nordicCheck">
											<label class="form-check-label" for="nordicCheck">
												Nordic LTE
											</label>
										</div>
										<div class="form-check">
											<input class="form-check-input" type="checkbox" v-model="selectedWatched.vodafone" disabled id="vodafoneCheck">
											<label class="form-check-label" for="vodafoneCheck">
												Vodafone WTTX
											</label>
										</div>
										<div class="form-check">
											<input class="form-check-input" type="checkbox" v-model="selectedWatched.xdsl" disabled id="xdslCheck">
											<label class="form-check-label" for="xdslCheck">
												xDSL
											</label>
										</div>
										<div class="form-check">
											<input class="form-check-input" type="checkbox" v-model="selectedWatched.all_changes" disabled id="allCheck">
											<label class="form-check-label" for="allCheck">
												Veškeré změny
											</label>
										</div>
									</div>
								</div>

								<div class="row d-md-none">
									<ul class="list-group col px-3 pt-4 my-list-small">
										<li class="list-group-item cursor-pointer text-left" v-if="selectedWatched.ruians.length < 1">Žádné sledování</li>
										<li class="list-group-item cursor-pointer text-left" v-for="(item, index) of selectedWatched.ruians" :key="index"> RUIAN:{{ item }} </li>
									</ul>
								</div>

								<div class="row d-md-none mt-4 ml-2">
									<div class="col text-left">
										<div class="form-check">
											<input class="form-check-input" type="checkbox" v-model="selectedWatched.nordic" disabled id="nordicCheck">
											<label class="form-check-label" for="nordicCheck">
												Nordic LTE
											</label>
										</div>
										<div class="form-check">
											<input class="form-check-input" type="checkbox" v-model="selectedWatched.vodafone" disabled id="vodafoneCheck">
											<label class="form-check-label" for="vodafoneCheck">
												Vodafone WTTX
											</label>
										</div>
										<div class="form-check">
											<input class="form-check-input" type="checkbox" v-model="selectedWatched.xdsl" disabled id="xdslCheck">
											<label class="form-check-label" for="xdslCheck">
												xDSL
											</label>
										</div>
										<div class="form-check">
											<input class="form-check-input" type="checkbox" v-model="selectedWatched.all_changes" disabled id="allCheck">
											<label class="form-check-label" for="allCheck">
												Veškeré změny
											</label>
										</div>
									</div>
								</div>

								<div class="row ml-2 d-none d-md-flex">
									<div class="col-10 text-left" v-if="! changingAddition">
										<div> Poznámka: {{ selectedWatched.addition }} </div>
										<button class="btn btn-sm btn-info" @click="changeAddition(selectedWatched.addition)"> Změnit </button>
									</div>
									<!-- <div class="col-6 " >

									</div> -->
									<div  v-else class="col-11 text-left input-group">
										<textarea class="form-control" type="text" rows="5" v-model="additionToChange"></textarea>
										<div class="input-group-append">
											<button v-if="additionToChange !== selectedWatched.addition" class="btn btn-success btn-outline-success" style="color: black;" type="button" id="button-addon2" @click="saveAddition(selectedWatched.id)" > ✓ </button>
											<button v-if="additionToChange !== selectedWatched.addition" class="btn btn-danger btn-outline-danger" style="color: black;" type="button" id="button-addon2" @click="returnAddition"> X </button>
										</div>
									</div>
								</div>

								<div class="row d-md-none mt-4 px-2 ">
									<!-- <div class="col text-left" v-if="! changingAddition">
										<div> Poznámka: {{ selectedWatched.addition }} </div>
										<button class="btn btn-sm btn-info" @click="changeAddition(selectedWatched.addition)"> Změnit </button>
									</div> -->
									<div class="col text-left input-group">
										<textarea class="form-control" type="text" rows="5" v-model="additionToChange"></textarea>
										<div class="input-group-append">
											<button v-if="additionToChange !== selectedWatched.addition" class="btn btn-success btn-outline-success" style="color: black;" type="button" id="button-addon2" @click="saveAddition(selectedWatched.id)" > ✓ </button>
											<button v-if="additionToChange !== selectedWatched.addition" class="btn btn-danger btn-outline-danger" style="color: black;" type="button" id="button-addon2" @click="returnAddition"> X </button>
										</div>
									</div>
								</div>

								<div class="row p-4 d-none d-md-flex">
									<div class="col-6">
									</div>
									<div class="col-6 text-left">
										<div> Zkontrolováno: {{ selectedWatched.timestamp_checked ? formatTime(selectedWatched.timestamp_checked) : 'Ještě nikdy.' }} </div>
										<div> Přidáno: {{ formatTime(selectedWatched.timestamp_created) }} </div>
										<div> <button class="btn btn-success mt-2" @click="checkWatch(selectedWatched.id)"> Zkontrolovat </button> </div>
										<div> <button class="btn btn-danger mt-4" @click="removeWatch(selectedWatched.id)"> Odstranit </button> </div>
									</div>
								</div>

								<div class="row d-md-none mt-4 px-2">
									<div class="col text-left">
										<div> Zkontrolováno: {{ selectedWatched.timestamp_checked ? formatTime(selectedWatched.timestamp_checked) : 'Ještě nikdy.' }} </div>
									</div>
								</div>

								<div class="row d-md-none mt-2 px-2">
									<div class="col text-left">
										<div> Přidáno: {{ formatTime(selectedWatched.timestamp_created) }} </div>
									</div>
								</div>

								<div class="row d-md-none mt-4 px-2 mb-4">
									<div class="col text-left">
										<div> <button class="btn btn-success" @click="checkWatch(selectedWatched.id)"> Zkontrolovat </button> </div>
									</div>
									<div class="col text-right">
										<div> <button class="btn btn-danger" @click="removeWatch(selectedWatched.id)"> Odstranit </button> </div>
									</div>
								</div>
							</div>
							<div class="col-lg-1">
							</div>
						</div>
					</div>
				</b-tab>

				<b-tab no-body title="Přidat sledování" class="nobg">
					<div class="container-fluid test py-4 mt-4">
						<div class="row justify-content-md-center">
							<div class="col-lg-4">
								<div class="form-group text-left">
									<label for="clientName"> Jméno zákazníka: </label>
									<input type="text" v-model="newWatch.firstName" class="form-control" id="clientName" placeholder="Franta" :class="{mydanger: nameMissing}" />
								</div>
							</div>
							<div class="col-lg-4">
								<div class="form-group text-left">
									<label for="clientLastName" > Příjmení zákazníka: </label>
									<input type="text" v-model="newWatch.lastName" class="form-control" id="clientLastName" placeholder="Ertepla" :class="{mydanger: nameMissing}" />
								</div>
							</div>
						</div>

						<div class="row justify-content-md-center">
							<div class="col-lg-4">
								<div class="form-group text-left ">
									<label for="clientPhone"> Telefon </label>
									<input type="text" v-model="newWatch.phone" class="form-control" id="clientPhone" placeholder="+420 777 777 777" :class="{mydanger: contactMissing}" />
								</div>
							</div>
							<div class="col-lg-4">
								<div class="form-group text-left">
									<label for="clientMail"> Email </label>
									<input type="email" v-model="newWatch.email" class="form-control" id="clientMail" placeholder="klient@klient.cz" :class="{mydanger: contactMissing}"/>
								</div>
							</div>
						</div>
						<div class="row justify-content-md-center">
							<div class="col-lg-8">
								<div class="form-group text-left ">
									<label for="clientPhone"> Poznámka </label>
									<input type="text" v-model="newWatch.addition" class="form-control" id="addition" placeholder="Nevim asi nejaka poznamka tady kdyz budeme chtit." />
								</div>
							</div>
						</div>

						<div class="row justify-content-md-left mt-4">
							<div class="col-lg-2">
							</div>
							<div class="col-lg-3">
								<ul class="list-group">
									<li v-if="myRuians.length < 1" class="list-group-item cursor-pointer" v-b-tooltip.hover title="Přidejte RUIAN kódy kliknutím na tlačítko Přidat RUIAN." :class="{mydanger: ruiansMissing}">Žádné RUIANy</li>
									<li
										v-for="item of myRuians"
										:key="item.index"
										class="list-group-item cursor-pointer d-flex justify-content-between align-items-center"
										v-b-tooltip.hover
										:title="item.city_name + '(' + item.city_part_name + ' ' + item.so_type + ') ' + item.city_street_name + ' ' + item.number_popisne + '/' + (item.number_orientacni + (item.sign_orientacni !== null ? item.sign_orientacni : '')) + ' ' + item.psc"

									>
										<span> {{ item.adresni_misto }} </span>
										<button class="btn btn-danger" @click="removeFromMyRuians(item.index)"> x </button>
									</li>
									<button class="btn btn-primary mt-2" v-b-modal.modal-1> Přidat RUIAN </button>
								</ul>
							</div>
							<div class="col-lg-1">
							</div>
							<div class="col-lg-3 mb-5 justify-content-md-left text-left d-none d-md-block" :class="{mydanger: watchingMissing}">
								<div class="form-check">
									<input class="form-check-input" type="checkbox" v-model="newWatch.watchNordic" id="nordicCheck">
									<label class="form-check-label" for="nordicCheck">
										Nordic LTE
									</label>
								</div>
								<div class="form-check">
									<input class="form-check-input" type="checkbox" v-model="newWatch.watchVodafone" id="vodafoneCheck">
									<label class="form-check-label" for="vodafoneCheck">
										Vodafone WTTX
									</label>
								</div>
								<div class="form-check">
									<input class="form-check-input" type="checkbox" v-model="newWatch.watchXdsl" id="xdslCheck">
									<label class="form-check-label" for="xdslCheck">
										xDSL
									</label>
								</div>
								<div class="form-check">
									<input class="form-check-input" type="checkbox" v-model="newWatch.watchAll" id="allCheck">
									<label class="form-check-label" for="allCheck">
										Veškeré změny(produkty)
									</label>
								</div>
							</div>
						</div>
						<div class="row d-md-none mt-4">
							<div class="col mb-2 justify-content-left text-left" :class="{mydanger: watchingMissing}">
								<div class="form-check">
									<input class="form-check-input" type="checkbox" v-model="newWatch.watchNordic" id="nordicCheck">
									<label class="form-check-label" for="nordicCheck">
										Nordic LTE
									</label>
								</div>
								<div class="form-check">
									<input class="form-check-input" type="checkbox" v-model="newWatch.watchVodafone" id="vodafoneCheck">
									<label class="form-check-label" for="vodafoneCheck">
										Vodafone WTTX
									</label>
								</div>
								<div class="form-check">
									<input class="form-check-input" type="checkbox" v-model="newWatch.watchXdsl" id="xdslCheck">
									<label class="form-check-label" for="xdslCheck">
										xDSL
									</label>
								</div>
								<div class="form-check">
									<input class="form-check-input" type="checkbox" v-model="newWatch.watchAll" id="allCheck">
									<label class="form-check-label" for="allCheck">
										Veškeré změny(produkty)
									</label>
								</div>
							</div>
						</div>
						<div class="row justify-content-md-end mt-5">
							<div class="col-lg-2">

							</div>
							<div class="col-lg-2 text-right">
								<button v-if="! adding" class="btn btn-primary" @click="startWatching"> Začít sledovat </button>
								<b-spinner v-else label="Spinning"></b-spinner>
							</div>
							<div class="col-lg-2">

							</div>
						</div>

					</div>
				</b-tab>

				<b-tab v-if="user.name === 'radek'" no-body title="Secret" class="nobg">
					<div class="container-fluid test px-4 py-4 mt-4">
						<div class="row"> Viable: </div>
						<div class="row">
							<div class="col-1">

							</div>

							<ul class="list-group col-4 px-2 mt-4 my-list-viable">
								<li class="list-group-item cursor-pointer text-left" v-for="v of viable" :key="v.id" @click="selectViable(v)"
								:class="{ active: viableSelected && v.id === viableSelected.id }"
								>
									<span> [ ID: {{ v.id }} ] </span>
									<span> [ created: {{ formatTime(v.timestamp_created) }} ] </span>
									<span> [ checked: {{ formatTime(v.timestamp_checked) }} ] </span>
								</li>
							</ul>

							<div class="col-1">

							</div>

							<div class="col-5 data-show" v-if="viableSelected">
								<div class="row">
									{{ viableSelected.first_name }} {{ viableSelected.last_name }}
								</div>
								<div class="row">
									Nordic: {{ viableSelected.nordic }}
								</div>
								<div class="row">
									Vodafone: {{ viableSelected.vodafone }}
								</div>
								<div class="row">
									xDSL: {{ viableSelected.xdsl }}
								</div>
								<div class="row">
									Produkty: {{ viableSelected.all_changes }}
								</div>
								<div class="row">
									Produkty: {{ viableSelected }}
								</div>
								<div v-for="s of viableSelected.data">
									<div class="row">
										{{ s }}
									</div>

								</div>
								<div class="row">
									<div class="col"> <button class="btn btn-success" @click="checkWatch(viableSelected.id, true)"> Zkontrolovat </button> </div>
								</div>
							</div>
						</div>
					</div>


				</b-tab>
			</b-tabs>
		</div>

		<b-modal id="modal-1" title="BootstrapVue" :size="'lg'" @hidden="resetModal">
			<template #modal-title>
				Přidat RUIAN kód.
			</template>
			<div class="d-block text-center">
				<div class="row">
					<input type="text" class="form-control col ml-2" id="ruian" placeholder="Zadejte adresu." v-model="searchString" @keyup.enter="fetchRuiany"/>
					<button class="btn btn-primary col-3 mx-2" @click="fetchRuiany"> Hledat </button>
				</div>
				<div class="row">
					<div class="col mt-4" v-if="fetchingRuiany">
						<b-spinner label="Spinning"></b-spinner>
					</div>
					<ul v-else class="list-group col px-2 mt-4 my-list">
						<li class="list-group-item cursor-pointer" v-if="ruians.length < 1">Žádné RUIANy</li>
						<li class="list-group-item cursor-pointer text-left" :class="{ active: activeItem.index === r.index }" v-for="r in ruians" :key="r.index" @click="setActive(r)">
							<span style="font-weight: bold;"> {{ r.city_name }} </span>
							<span :class="{ myactive: activeItem.index === r.index, mynotactive: activeItem.index !== r.index }"> ({{ r.city_part_name }}, {{ r.so_type }}) </span>
							<span> {{ r.city_street_name }} </span>
							<span> {{ r.number_popisne }}/{{ r.number_orientacni + (r.sign_orientacni !== null ? r.sign_orientacni : '') }} - {{ r.psc }} </span>
						</li>
					</ul>
				</div>
			</div>
			<template #modal-footer>
				<div class="row">
					<button class="btn btn-secondary px-3 py-2 mr-2" @click="cancelModal"> Zrušit </button>
					<button class="btn btn-primary px-3 py-2 mr-2" @click="addFromModal"> Přidat </button>
				</div>
			</template>
		</b-modal>

    <b-modal id="modal-2" title="BootstrapVue2" :size="'lg'" @hidden="resetModalMessage">
			<template #modal-title>
				Chyba při přidávání pohledávky.
			</template>
			<div class="d-block text-center">
				{{ modalMessage }}
			</div>
			<template #modal-footer>
				<div class="row">
					<button class="btn btn-secondary px-3 py-2 mr-2" @click="cancelModalMessage"> Zavřít </button>
				</div>
			</template>
		</b-modal>
	</div>
</template>

<script>
import AdditionsService from '@/services/AdditionsService'
import { mapGetters } from 'vuex'


export default {
	name: 'UpgradeView',

	components: {

	},

	data() {
		return {
			viable: [],
			viableSelected: null,
			user: {},
			ruians: [],
			myRuians: [],
			fetchingRuiany: false,
			searchString: '',
			activeItem: { index: 0 },
			vyhledavani: '',

			watchNordic: false,
			watchVodafone: false,
			watchXdsl: false,
			watchAll: false,
			adding: false,
			newWatch: {
				firstName: '',
				lastName: '',
				phone: '',
				email: '',
				addition: '',
				watchNordic: false,
				watchVodafone: false,
				watchXdsl: false,
				watchAll: false,
			},

			watching: [],
			fetchingWatching: false,
			selectedWatchedId: 0,
			selectedWatched: null,

			nameMissing: false,
			contactMissing: false,
			ruiansMissing: false,
			watchingMissing: false,
			newWatching: [],
			additionToChange: '',
			changingAddition: true,
      modalMessage: '',
		}
	},

	async mounted () {
		await this.fetchWatching()
		await this.fetchViable()
		this.setUserObject()
	},

	computed: {
		nameToWatch () {
			return this.newWatch.firstName + this.newWatch.lastName
		},

		contactToWatch () {
			return this.newWatch.email + this.newWatch.phone
		},

		ruiansToWatch () {
			return this.myRuians.length
		},

		watchingToWatch () {
			const hold = []
			if (this.newWatch.watchNordic) {
				hold.push(true)
			}

			if (this.newWatch.watchVodafone) {
				hold.push(true)
			}

			if (this.newWatch.watchXdsl) {
				hold.push(true)
			}

			if (this.newWatch.watchAll) {
				hold.push(true)
			}
			return hold
		}
	},

	methods: {
		...mapGetters([
            'getUserObject',
		]),

		async fetchViable () {
			const hold = await AdditionsService.fetchViable()
			this.viable = hold.data
			this.viableSelected = null
		},

		selectViable (to) {
			this.viableSelected = to
		},

		setUserObject () {
			this.user = this.getUserObject()
		},

		setWatchedActive (item) {
			this.selectedWatched = item
			this.selectedWatchedId = item.id
			this.additionToChange = item.addition
		},

		async fetchWatching () {
			this.fetchingWatching = true
			const user = this.getUserObject()
			const watching = await AdditionsService.fetchWatching(user.id)
			this.watching = watching.data
			this.newWatching = watching.data
			this.fetchingWatching = false
			this.selectedWatched = null
			this.selectedWatchedId = 0
		},

		async removeWatch (id) {
			this.selectedWatched = null
			this.selectedWatchedId = 0
			await AdditionsService.removeWatch(id)
			await this.fetchWatching()
		},

		async checkWatch (id, secret = false) {
			await AdditionsService.checkWatch(id)
			if (secret) {
				await this.fetchViable()
			}
		},

		async startWatching () {
            const user = this.getUserObject()

			if ((this.newWatch.firstName === '' && this.newWatch.lastName === '')) {
				this.nameMissing = true
			}

			if ((this.newWatch.phone === '' && this.newWatch.email === '')) {
				this.contactMissing = true
			}

			if (this.myRuians.length < 1) {
				this.ruiansMissing = true
			}

			if ((! this.newWatch.watchNordic) && (! this.newWatch.watchVodafone) && (! this.newWatch.watchXdsl) && (! this.newWatch.watchAll)) {
				this.watchingMissing = true
			}

			if (this.nameMissing || this.contactMissing || this.ruiansMissing || this.watchingMissing) {
				return
			}
			this.adding = true

			const ok = await AdditionsService.startWatching(this.newWatch, this.myRuians.map(e => e.adresni_misto), user.id);
      if (! ok.data.passed) {
        this.modalMessage = ok.data.message;
			  this.$bvModal.show('modal-2')

        this.adding = false;
        return;
      }
			this.newWatch = {
				firstName: '',
				lastName: '',
				phone: '',
				email: '',
				addition: '',
				watchNordic: false,
				watchVodafone: false,
				watchXdsl: false,
				watchAll: false,
			}

			this.myRuians = []
			this.adding = false
			await this.fetchWatching()
		},

		removeFromMyRuians (index) {
			this.myRuians = this.myRuians.filter(e => e.index !== index)
		},

		async removeWatch (id) {
			const rly = window.confirm('Opravdu odstranit?')
			if (! rly) {
				return
			}
			this.selectedWatchedId = 0
			this.selectedWatched = null
			await AdditionsService.removeWatch(id)
			await this.fetchWatching()
		},

		resetModal () {
			this.fetchingRuiany = false
			this.searchString = ''
			this.ruians = []
			this.activeItem = { index: 0 }
		},

    resetModalMessage () {
      this.modalMessage = '';
		},

		cancelModal () {
			this.$bvModal.hide('modal-1')
		},

    cancelModalMessage () {
			this.$bvModal.hide('modal-2')
		},

		addFromModal () {
			this.myRuians.push(this.activeItem)
			this.$bvModal.hide('modal-1')
		},

		async fetchRuiany () {
			this.fetchingRuiany = true
      const user = this.getUserObject()
      const ruiany = await AdditionsService.secondHit(this.searchString, user.name)
			this.ruians = ruiany.data
			this.fetchingRuiany = false
		},

		setActive (item) {
			this.activeItem = item
		},

		formatTime (timestamp) {
			const newDate = new Date(timestamp)
			newDate.setHours(newDate.getHours() + 1)
            const timeFormattedYear = newDate.getUTCFullYear()
            const timeFormattedMonth = newDate.getUTCMonth() + 1
            const timeFormattedDay = newDate.getUTCDate()

            const timeFormattedHour = newDate.getUTCHours()
            const timeFormattedMinute = newDate.getUTCMinutes()
            const timeFormattedSecond = newDate.getUTCSeconds()

            return timeFormattedDay + '.' + timeFormattedMonth + '.' + timeFormattedYear + ' - ' + timeFormattedHour + ':' + timeFormattedMinute + ':' + timeFormattedSecond
		},

		changeAddition (to) {
			this.additionToChange = to
			this.changingAddition = true

		},

		async saveAddition (id) {
			const done = await AdditionsService.saveAdditionOnUpgrade(this.additionToChange, id)
			this.selectedWatched.addition = this.additionToChange
			// this.changingAddition = false
		},

		returnAddition (to) {
			this.additionToChange = this.selectedWatched.addition
			// this.changingAddition = false
		}
	},

	watch: {
		nameToWatch (to) {
			if (to !== '') {
				this.nameMissing = false
			}
		},

		contactToWatch (to) {
			if (to !== '') {
				this.contactMissing = false
			}
		},

		ruiansToWatch (to) {
			if (to !== 0) {
				this.ruiansMissing = false
			}
		},

		watchingToWatch (to) {
			if (to.length !== 0) {
				this.watchingMissing = false
			}
		},

		vyhledavani (to) {
			const lowerTo = to.toLowerCase()
			if (to !== '') {
				const holdSledovani = [...this.watching]
				this.newWatching = holdSledovani.filter(e => {
					const hold = (e.first_name + ' ' + e.last_name).toLowerCase()
					if (hold.includes(lowerTo) || e.ruians.includes(lowerTo)) {
						return true
					}
				})
			}

			if (to === '') {
				this.newWatching = this.watching
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.nonobg
	background-color #e0ecff
	text-decoration none
	color black

.nonobg a
	text-decoration none

.upgrade-view
	display flex
	background-color #e0ecff
	min-height 100vh

.cursor-pointer
	cursor pointer

.my-list
	max-height 400px
	overflow-y scroll
	background-color white
	padding 0px

.my-list-viable
	max-height 550px
	overflow-y scroll
	background-color white
	padding 0px

.data-show
	background-color white

.info-back
	background-color white
	border-radius 0.25rem

.my-list-min
	min-height 400px

.myactive
	color white

.mynotactive
	color gray

.nobg
	background-color #e0ecff !important
	border-bottom none !important
	margin-top 0px

.my-word
	font-size 20px
	line-height 30px

.my-word-response
	font-size 20px
	line-height 30px

.my-list-small
	max-height 200px
	// overflow-y scroll
	padding 0px

.red-border
	border 1px solid red

.mydanger
	border 1px solid #ff4564

.my-search
	display flex
	flex-direction row

</style>



// WEBPACK FOOTER //
// src/views/UpgradeView.vue